module.exports = __webpack_public_path__ + "static/img/sb_03.e6e56d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/sb_03.jpg
// module id = a+Y0
// module chunks = 0